var fieldPicker = angular.module('fieldPicker', []);
fieldPicker.directive('fieldPicker', ['$q', 'curriculumManager', 'settings', function ($q, CurriculumManager, settings) {
  'use strict';
  return {
    restrict: 'E',
    template: require('./fieldPicker.html'),
    replace: true,
    transclude: true,
    //require: [ '^xyz' ], //requires a controller from the parent scope
    scope: {
      selected: '='
    },
    link: function (scope, element, attrs) {

      CurriculumManager.getFields().then(function (fields) {
        scope.fields = fields;
        var i, field;
        for (i = 0; i < fields.length; i++) {
          field = fields[i];
          field.style = {
            'background-color': field.color
          };
        }
      });

      scope.getImgSrc = function (field) {
        var href, i;
        for (i = 0; i < field.attachments.length; i++) {
          if (field.attachments[i].type === 'ICON') {
            href = field.attachments[i].href;
            break;
          }
        }
        return settings.apisAndUrls.api + href;
      };

    }
  };
}]);

module.exports = fieldPicker;


// WEBPACK FOOTER //
// ./web/js/module/field-picker/fieldPicker.js